import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectAccountComponent } from './select-account/select-account.component';
import { SigninComponent } from './signin/signin.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LayoutModule } from './../../layout/layout.module';
import { UnauthorisedComponent } from 'src/app/layout/unauthorised/unauthorised.component';
import { AuthGuard } from 'src/app/services/guards/auth.guard';
import { universalLoginGuard } from 'src/app/services/guards/universal-login.guard';

const routes: Routes = [
  {
    path: 'select-account',
    component: SelectAccountComponent,
    canActivate: [universalLoginGuard, AuthGuard],
  },
  {
    path: '',
    component: UnauthorisedComponent,
    canActivate: [universalLoginGuard],
    children: [
      {
        path: 'signin',
        component: SigninComponent
      },
      { path: 'forgotpassword', component: ForgotPasswordComponent },
      // Route for creating passwords for newly onboarded clients - do not link internally
      { path: 'setuppassword', component: ForgotPasswordComponent, data: { isNewUserPassword: true } },
      // route to handle invite link - joint investor
      { path: 'resetpassword/:invite', component: ResetPasswordComponent, pathMatch: 'full' },
      { path: 'resetpassword', component: ResetPasswordComponent, pathMatch: 'full' },
      { path: 'sso', component: SigninComponent },
      { path: '**', redirectTo: 'signin' }
    ]
  }
];

@NgModule({
  imports: [
    LayoutModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
